import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=3d2c6c54&scoped=true&"
import script from "./ModalEdit.vue?vue&type=script&lang=js&"
export * from "./ModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2c6c54",
  null
  
)

export default component.exports